import Vue from "vue";
import Router from "vue-router";
import routes from "./routes";
import store from "../store";
import pub from "../util/plugins";

Vue.use(Router);

const router = new Router({
  mode: "history",
  scrollBehavior: () => ({ y: 0 }),
  base: process.env.BASE_URL,
  routes,
});

// const excludeRoute = ['Login', 'SmsLogin', 'ForgetPass', 'BindMobile', 'SetPass', 'Treaty', 'Index', 'Course', 'Record', 'Person', 'Practise'];
const excludeRoute = ["Pay"];
/**
 * 底部tab显隐控制
 */
router.beforeEach(async (to, from, next) => {
  if (to.meta.footer) {
    store.commit("SET_FOOT", to.name);
  } else {
    store.commit("SET_FOOT");
  }
  // 设置title，如果没有则显示空格，这里直接用空格的话，会显示当前url
  document.title = to.meta.title || "\u200E";
  // 解决ios微信复制链接和分享，url始终不变的问题
  // if (pub.isWeiXin() && !excludeRoute.includes(to.name) && to.path !== location.pathname) {
  //     location.assign(to.fullPath);
  // }
  store.dispatch("setShare", { share_type: 1, route: to });
  if (pub.isWeiXin() && !excludeRoute.includes(to.name)) {
    store.dispatch("setShare", { share_type: 1, route: to });
  }
  if (from.name && from.name.indexOf("Tea") && to.name.indexOf("Tea")) {
    localStorage.removeItem("teacher_id");
  }
  const excludeRouter = [
    "Person",
    "SmsLogin",
    "Login",
    "ForgetPass",
    "Treaty",
    "BindMobile",
    "SetNewPass",
    "SetPass",
    "Group",
    "GroupDetail",
    "MyGroup",
    "GroupRule",
    "AllGroup",
    "NewsDetail",
    "CourseDetail",
    "ExerciseDetail",
    "ExamDetail",
    "BookDetail",
  ];

  if (excludeRouter.includes(to.name) || to.name.indexOf("Tea") > -1) {
    store.commit("SET_CLASSIFY", false);
  } else {
    // 获取app内选的classify_id
    if (pub.GetQueryValue("classify_id")) {
      await localStorage.setItem(
        "classify_id",
        pub.GetQueryValue("classify_id")
      );
      if (localStorage.adminToken) {
        pub.setClassify();
      }
    }
    let { app } = pub.app_js();
    // 在app中不弹分类的弹框
    if (!app) {
      if (localStorage.adminToken) {
        //已登录
        await store.dispatch("getPerson");
        if (store.state.personInfo.classify_id || localStorage.classify_id) {
          //有分类不显示弹框
          store.commit("SET_CLASSIFY", false);
        } else {
          store.commit("SET_CLASSIFY", true);
        }
      } else {
        //未登录
        if (localStorage.classify_id) {
          //有分类
          store.commit("SET_CLASSIFY", false);
        } else {
          store.commit("SET_CLASSIFY", true);
        }
      }
    }
  }
  if (to.query.share_info) {
    sessionStorage.setItem("courseShareInfo", to.query.share_info);
  }
  if (
    (to.name == "SmsLogin" && from.name != "Login") ||
    (to.name == "Login" && from.name != "SmsLogin")
  ) {
    localStorage.setItem("redirect", from.fullPath);
  }
  next();
});

export default router;
